import { connect } from "react-redux";

import KompressorImage from "./KompressorImage";

export default connect(state => ({
	errors: state.ablauf.errors
}))(KompressorImage);
